import { Component, Injector, OnInit, ViewChild, TemplateRef,HostListener } from '@angular/core';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { CnaePermitidoService, MascaraDto, NovoCnaePermitidoDTO } from '../cnae-permitido.service';
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { MascaraCnaePermitido } from 'src/app/model/mascara-cnae-permitido.model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DatePipe, Location } from "@angular/common";
import moment from "moment";
import { ExportService } from '../../habilitacao/export.service';
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { MensagemService } from "src/app/features/mensagem.service";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { Router } from '@angular/router';

export interface CodigoCnaeDTO{
  codigo: string;
}

@Component({
    selector: 'app-cnae-permitido-pesquisa',
    templateUrl: './cnae-permitido-pesquisa.component.html',
    standalone: false
})
export class CnaePermitidoPesquisaComponent implements OnInit {
  ideTranche: number;
  tranches: Tranche[] = [];
  tipoOperacaoSelect: any;
  objetivoFinanciamentoSelect: any;
  // mascaras: MascaraDto[];
  atributosPaginacaoComponenteListagem: EntityPagedResult<MascaraCnaePermitido>;
  opcoesPaginacao: number[];
  pesquisaForm: UntypedFormGroup;
  cnaesPermitidos: MascaraCnaePermitido[];
  msgSemResultado: boolean = false;
  dataHoraResultado: string;
  // codigosCnae: CodigoCnaeDTO[] = [];
  codigoCnaeSelecionado: string;
  dataInicioValidadePermissao: Date;
  tipoOperacaoNovo: string = null;
  objetivoFinanciamentoNovo: string = null;
  dataHoje = new Date();
  mascaraIsPresent: boolean = true;
  dataInicioIsPresent: boolean = true;
  podeCadastrarEncerrar: boolean = false;

  @ViewChild('botoes') botoesPersonalizados: TemplateRef<any>;
  @ViewChild('modalCadastrar') msgPersonalizada: TemplateRef<any>;

  constructor(
    private trancheService: TrancheService,
    private cnaePermitidoService: CnaePermitidoService,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe,
    private bnLoadingService: BnLoadingService,
    private exportService: ExportService,
    private modalService: BnModalMessageService,
    private mensagemService: MensagemService,
    private permissaoService: PermissaoService,
    private router: Router
  ) {
    this.pesquisaForm = this.formBuilder.group({
      idTranche: null,
      mascara: null,
      dataInicioVigencia: null,
      dataFimVigencia: null,
      tipoOperacao: null,
      objetivoFinanciamento: null
    });
   }

  ngOnInit(): void {

    this.opcoesPaginacao = [10, 15, 20];
    this.permissaoService.getPermissoesUsuarioAutenticado()
      .subscribe((resp: any) => {
        this.podeCadastrarEncerrar = resp && resp[ROLE_GESTOR_ENVIO];
      });
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
    
    this.tipoOperacaoSelect = [
      {label: 'R - Repasse BNDES', value: 'R'},
      {label: 'L - Crédito Livre', value: 'L'},
    ]

    this.objetivoFinanciamentoSelect = [
      {label: 'G - Empréstimo/Capital de Giro', value: 'G'},
      {label: 'I - Investimento', value: 'I'},
    ]

    this.dataHoje.setDate(this.dataHoje.getDate() + 1);
    this.carregarDados();
    
  }

  mudancaPagina(novaPagina: EntityPagedResult<MascaraCnaePermitido>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(true);
  }

  async carregarDados() {
    this.trancheService.getTranches().subscribe(tranches => {
      this.tranches = tranches;
    });
  }

  limpar() {
    this.ideTranche = null;
    this.pesquisaForm.reset();
    this.atributosPaginacaoComponenteListagem.page = 1;
    this.cnaesPermitidos = [];
  }

  buscar(paginado: boolean) {
    this.bnLoadingService.bloqueiaTela();
    const dadosPreenchidos = this.tratarInformacoesPreenchidas();
    dadosPreenchidos.pagina = paginado ? this.atributosPaginacaoComponenteListagem.page : 1;
    dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    
    this.cnaePermitidoService.getCnaesPermitidos(dadosPreenchidos).subscribe(response => {
      this.cnaesPermitidos = response ? response.resultados : null;
      this.atributosPaginacaoComponenteListagem.count = response ?
        response.totalRegistrosSemPaginacao : 0;
      this.msgSemResultado = (this.atributosPaginacaoComponenteListagem.count === 0) || false;
    });

    this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
    this.bnLoadingService.liberaTela();
  }

  tratarInformacoesPreenchidas() {
    const form = this.pesquisaForm.value;
    let dadosPreenchidos: any = {};
    
    if (this.ideTranche) {
      dadosPreenchidos.idTranche = this.ideTranche;
    }
    if (form.mascara) {
      dadosPreenchidos.mascara = form.mascara;
    }
    if (form.dataInicioVigencia) {
      dadosPreenchidos.dataInicioValidade = this.datePipe.transform(form.dataInicioVigencia, 'yyyyMMdd');
    }
    if (form.dataFimVigencia) {
      dadosPreenchidos.dataFimValidade = this.datePipe.transform(form.dataFimVigencia, 'yyyyMMdd');
    }
    if (form.tipoOperacao) {
      dadosPreenchidos.tipoOperacao = form.tipoOperacao;
    }
    if (form.objetivoFinanciamento) {
      dadosPreenchidos.objetivoFinanciamento = form.objetivoFinanciamento;
    }

    return dadosPreenchidos;
  }

  exportarCnaesPermitidos() {
    this.bnLoadingService.bloqueiaTela();
    const dadosPreenchidos = this.tratarInformacoesPreenchidas();
    this.cnaePermitidoService.getCnaesPermitidos(dadosPreenchidos).subscribe(response => {
      this.exportService.exportarCnaesPermitidos(response);
    });
  }

  irParaCadastro() {
    this.router.navigate(['cnaes-permitidos', 'cadastro', this.ideTranche]);
  }

}